document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.anchor-link a[data-target]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = anchor.getAttribute('data-target');

      if (target === 'overview') {
        // Navigate to the first section containing either "banner" or "image-with-text" class
        const overviewSection = Array.from(document.querySelectorAll('div'))
          .find((section) => 
            section.classList.contains('banner') || 
            section.classList.contains('image-with-text')
          );

        if (overviewSection) {
          overviewSection.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (target === 'compatibility') {
        // Find the section with "shopify-section-template" and "product_details"
        const compatibilitySection = document.querySelector(
          '[id*="shopify-section-template"][id*="product_details"]'
        );
        if (compatibilitySection) {
          compatibilitySection.scrollIntoView({ behavior: 'smooth' });

          // Close all other accordions
          compatibilitySection.querySelectorAll('details[is="accordion-details"]').forEach((details) => {
            details.removeAttribute('open');
            details.setAttribute('aria-expanded', 'false');
            const content = details.querySelector('.details__content');
            if (content) {
              content.style.opacity = '0';
              content.style.transform = 'translateY(-10px)';
            }
          });

          // Find and open the accordion with the title "COMPATIBILITY"
          const compatibilityAccordion = Array.from(
            compatibilitySection.querySelectorAll('details[is="accordion-details"]')
          ).find((details) => {
            const titleElement = details.querySelector('summary .heading');
            return titleElement && titleElement.textContent.trim().toUpperCase().includes('COMPATIBILITY');
          });

          if (compatibilityAccordion) {
            compatibilityAccordion.setAttribute('open', '');
            compatibilityAccordion.setAttribute('aria-expanded', 'true');

            const contentElement = compatibilityAccordion.querySelector('.details__content');
            if (contentElement) {
              contentElement.style.opacity = '1';
              contentElement.style.transform = 'translateY(0px)';
            }
          }
        }
      } else if (target === 'faq') {
        // Find the section with "shopify-section-template" and "faq"
        const faqSection = document.querySelector('[id*="shopify-section-template"][id*="faq"]');
        if (faqSection) {
          faqSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});